module.exports = __webpack_public_path__ + "img/1.c3ab7b71.jpg";